// Instância Axios dedicada à API externa de Regularização Suplementar (parceria
// AASP) — usada só pelo pedido de Inscrição Suplementar, pra saber se a pessoa
// logada já foi notificada/pagou pendência com a AASP. Autenticação por token
// fixo (não é o JWT do login nem o x-api-key da API de Protocolo/Títulos).

import axios from 'axios';

const regularizeSuplementarApi = axios.create({
  baseURL: process.env.REACT_APP_REGULARIZE_SUPLEMENTAR_API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: process.env.REACT_APP_REGULARIZE_SUPLEMENTAR_API_TOKEN
  }
});

export default regularizeSuplementarApi;
